export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8843.a8836fc6.jpg";